import React from 'react';

import {
  Tooltip,
  Typography
} from '@mui/material';

import NA from './NA';

// "last seen" only means something relative to now — an absolute timestamp
// forces the reader to do the subtraction. Show the relative form and keep the
// exact timestamp on hover.
export const formatTimeAgo = (value) => {
  if (!value) return null;

  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return null;

  const seconds = Math.round((Date.now() - then) / 1000);

  if (seconds < 0) return "just now";
  if (seconds < 60) return `${seconds}s ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;

  return `${Math.floor(months / 12)}y ago`;
};

const TimeAgo = ({ value, color }) => {
  const relative = formatTimeAgo(value);

  if (!relative) return <NA />;

  return (
    <Tooltip title={new Date(value).toString().substring(0, 33)}>
      <Typography
        variant='body2'
        sx={{ whiteSpace: "nowrap", color: color || "inherit" }}>
        {relative}
      </Typography>
    </Tooltip>
  )
}

export default TimeAgo;
